import React, { useCallback, useEffect, useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-169 · staff form for "from the internet" sources, per event or per curator.
const blank = { name: "", figure: "", summary: "", link: "", last_checked: "" };
const inp = { height: 34, padding: "0 8px", background: "rgba(18,18,42,0.72)", border: "1px solid var(--line-night)",
  borderRadius: 8, color: "var(--text-night)", fontSize: 12, width: "100%", colorScheme: "dark" };

export const InternetSourcesEditor = ({ eventId, handle }) => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ ...blank, scope: "event" });
  const load = useCallback(async () => {
    const p = new URLSearchParams({ event_id: eventId });
    if (handle) p.set("organiser_handle", handle);
    const r = await client.get(`/admin/internet-sources?${p}`);
    setRows(r.data.sources || []);
  }, [eventId, handle]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!form.name.trim()) return toast.error("source name needed");
    try {
      await client.post("/admin/internet-sources", { ...form, event_id: eventId, organiser_handle: handle });
      setForm({ ...blank, scope: form.scope });
      toast.success("source added");
      load();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "could not add · links must start with https://");
    }
  };
  const remove = async (id) => { await client.delete(`/admin/internet-sources/${id}`); load(); };
  const f = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  return (
    <div data-testid="internet-sources-editor" className="mt-5 rounded-md border p-3" style={{ borderColor: "var(--line-night)" }}>
      <p className="text-xs font-semibold lowercase" style={{ color: "var(--text-muted-night)" }}>from the internet · staff only, never counts toward the score</p>
      <ul className="mt-2 grid gap-1">
        {rows.map((s) => (
          <li key={s.id} data-testid={`internet-source-row-${s.id}`} className="flex items-center gap-2 text-xs" style={{ color: "var(--text-night)" }}>
            <span className="rounded px-1" style={{ border: "1px solid var(--line-night)" }}>{s.scope === "curator" ? "curator" : "event"}</span>
            <span className="flex-1 truncate">{s.name} · {s.figure} · {s.summary}</span>
            <button data-testid={`internet-source-delete-${s.id}`} onClick={() => remove(s.id)} className="underline lowercase">remove</button>
          </li>
        ))}
        {!rows.length && <li className="text-xs" style={{ color: "var(--text-dim-night)" }}>no sources yet</li>}
      </ul>
      <div className="mt-3 grid gap-2" style={{ gridTemplateColumns: "1fr 1fr" }}>
        <select data-testid="internet-source-scope" value={form.scope} onChange={f("scope")} style={inp}>
          <option value="event">this event</option>
          {handle && <option value="curator">this curator (@{handle})</option>}
        </select>
        <input data-testid="internet-source-name" placeholder="source name" value={form.name} onChange={f("name")} style={inp} />
        <input data-testid="internet-source-figure" placeholder="figure, e.g. 4.3 out of 5" value={form.figure} onChange={f("figure")} style={inp} />
        <input data-testid="internet-source-checked" type="date" value={form.last_checked} onChange={f("last_checked")} style={inp} />
        <input data-testid="internet-source-summary" placeholder="one line summary in our words" value={form.summary} onChange={f("summary")} style={{ ...inp, gridColumn: "1 / -1" }} />
        <input data-testid="internet-source-link" placeholder="link" value={form.link} onChange={f("link")} style={{ ...inp, gridColumn: "1 / -1" }} />
      </div>
      <button data-testid="internet-source-add" onClick={add} className="mt-2 text-xs font-semibold lowercase hover:underline" style={{ color: "var(--kili)" }}>
        + add source
      </button>
    </div>
  );
};
